import { InputContainer } from "@ui/InputContainer";
import { RadioGroup } from "@ui/RadioGroup";

type Props = {
	value: "public" | "private";
	onChange: (value: "public" | "private") => void;
};

export const PrivacyRadioGroup = (props: Props) => {
	return (
		<InputContainer>
			<label for="privacy">Privacy</label>
			<RadioGroup
				variant="card"
				value={props.value}
				onChange={(value) => {
					props.onChange(value as "public" | "private");
				}}
				options={[
					{
						value: "public",
						label: "Public",
						symbol: "public",
						description: "Anyone with the link can view this board.",
					},
					{
						value: "private",
						label: "Private",
						symbol: "lock",
						description: "Only you and your agencies can view this board.",
					},
				]}
			/>
		</InputContainer>
	);
};
